import { computed } from "vue";

type LocalImageMap = ReadonlyMap<string, string>;

const imageModules = import.meta.glob<{ default: string }>(
  "@/assets/**/*.{png,jpg,jpeg,svg,gif,webp}",
  { eager: true },
);

const localImagesByFileName: LocalImageMap = new Map(
  Object.entries(imageModules).map(([path, module]) => [
    path.split("/").pop() || path,
    module.default,
  ]),
);

function joinUrl(baseUrl: string, path: string): string {
  if (!baseUrl) return path;
  return `${baseUrl.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
}

export function resolveAssetImage(
  img: string,
  localImages: LocalImageMap = localImagesByFileName,
  downloadBaseUrl = import.meta.env.VITE_API_DOWNLOAD_BASE_URL || "",
): string {
  if (!img) return "";

  if (/^(?:https?:|data:|blob:)/i.test(img)) return img;

  if (img.startsWith("/output/") || img.startsWith("output/")) {
    const path = img.startsWith("/") ? img : `/${img}`;
    return joinUrl(downloadBaseUrl, path);
  }

  const fileName = img.split("/").pop() || img;
  return localImages.get(fileName) || img;
}

export function useAssetsImgs(img: string) {
  const imageUrl = computed(() => {
    const resolved = resolveAssetImage(img);
    if (resolved === img && img && !/^(?:https?:|data:|blob:)/i.test(img)) {
      console.warn(`Image not found: ${img}`);
    }
    return resolved;
  });

  return { imageUrl };
}
